module.exports = __webpack_public_path__ + "static/media/star-filled.319f91ed.svg";